import Alpine from 'alpinejs';
import InitNavigation from './initNavigation';
import InitGlobal from './initGlobal';
import InitSwiper from './initSwiper';

InitNavigation();
InitGlobal();
InitSwiper();

window.Alpine = Alpine;
Alpine.start();
